
import { computed, defineComponent, onBeforeMount, ref } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { checkFeature, FeatureType } from '@invivodf/front-seller-feature-flipping'
import { useStore } from '@/composables/useStore'
import { offerService } from '../../services'

export default defineComponent({
  name: 'CImportOffers',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()
    const useZip = ref(false)
    const isExportDisabled = ref(true)

    // Computed passés en composition API
    const cooperativeId = computed(() => store.getters.cooperativeId)
    const cooperative = computed(() => store.getters.cooperative)

    const allCsvProperties = computed(() => [
      {
        importType: 'importFull',
        name: useZip.value ? 'offers.zip' : 'offers.csv',
        acceptedFiles: useZip.value ? '.zip' : '.zip, .csv',
        full_path: useZip.value ? '/assets/zip/offers.zip' : '/assets/csv/offers.csv',
        importSectionTitle: 'ctx.import.offers__import-full-section-title',
        importSectionLabel: 'ctx.import.offers__import-full-section-label',
        uploadButtonLabel: 'ctx.import.offers__import-full-upload-button-label',
      },
      {
        importType: 'importDelta',
        name: useZip.value ? 'offers.zip' : 'offers.csv',
        acceptedFiles: useZip.value ? '.zip' : '.zip, .csv',
        full_path: useZip.value ? '/assets/zip/offers.zip' : '/assets/csv/offers.csv',
        importSectionTitle: 'ctx.import.offers__import-delta-section-title',
        importSectionLabel: 'ctx.import.offers__import-delta-section-label',
        uploadButtonLabel: 'ctx.import.offers__import-delta-upload-button-label',
      },
      {
        name: 'offers_delete.csv',
        full_path: '/assets/csv/offers_delete.csv',
        importType: 'importDelete',
        importSectionTitle: 'ctx.import.offers__import-delete-section-title',
        importSectionLabel: 'ctx.import.offers__import-delete-section-label',
        uploadButtonLabel: 'ctx.import.offers__import-delete-upload-button-label',
      },
    ])

    onBeforeMount(async () => {
      useZip.value = store.getters.isPartnerWithNewOfferConfiguration
      isExportDisabled.value = await checkFeature.execute({
        id: 'front-seller:disable-offers-export',
        type: FeatureType.Dynamic,
      })
    })

    function downloadCSV() {
      return offerService.downloadOffers(cooperativeId.value, cooperative.value.name)
    }

    const importInformation = computed(() => ({
      count: null,
      format: useZip.value ? 'zip' : 'csv',
      lastImportAt: null,
    }))

    return {
      allCsvProperties,
      offerService,
      importInformation,
      cooperativeId,
      cooperative,
      isExportDisabled,
      downloadCSV,
    }
  },
})
